const Big = require('big.js');

const toBig = value => {
	const number = Number(value);
	return Big(Number.isFinite(number) ? number : 0);
};

const returnLineUnitPrice = ({ soldQuantity, soldAmount }) => {
	const quantity = toBig(soldQuantity);
	if (!quantity.gt(0)) return 0;
	return toBig(soldAmount)
		.div(quantity)
		.round(5)
		.toNumber();
};

const completesInvoiceLine = ({ quantity, soldQuantity, returnedQuantity }) =>
	toBig(returnedQuantity)
		.plus(toBig(quantity))
		.eq(toBig(soldQuantity));

const returnLineAmount = ({
	quantity,
	soldQuantity,
	soldAmount,
	returnedQuantity,
	returnedAmount
}) => {
	const weight = toBig(quantity);
	const sold = toBig(soldQuantity);
	if (!weight.gt(0) || !sold.gt(0)) return 0;
	if (completesInvoiceLine({ quantity, soldQuantity, returnedQuantity }))
		return toBig(soldAmount)
			.minus(toBig(returnedAmount))
			.toNumber();
	const exact = weight.times(toBig(soldAmount));
	const amount = exact.div(sold).round(2, Big.roundDown);
	return (amount.times(sold).gt(exact)
		? amount.minus('0.01')
		: amount
	).toNumber();
};

module.exports = {
	returnLineAmount,
	returnLineUnitPrice,
	completesInvoiceLine
};
